<template>
  <div class="content">
    <controlbar
      :dispItems="loginUsers"
      @input-event="setLoginUsers"
      @reload="reload"
      @clear-isOpen="clearIsOpen"
      @clearFileDownloadUserIDList="clearFileDownloadUserIDList"
    >
    </controlbar>
    <loginUserPostList
      ref="child1"
      :dispItems="loginUserPostList"
      @change-post="setLoginPostUsers"
      @clearFileDownloadUserIDList="clearFileDownloadUserIDList"
    ></loginUserPostList>
    <div class="center_loginUser">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents_loginUser_img"></td>
          <td class="table_contents_loginUser">
            <label class="careworker_name_label">
              {{ careworkerNameLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="post_name_label">
              {{ postNameLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="job_label">
              {{ jobLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="position_label">
              {{ positionLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="phoneNumber_label">
              {{ phoneNumberLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="status_label">
              {{ statusLabel }}
            </label>
          </td>
          <td class="table_contents_loginUser">
            <label class="last_login_datetime_label">
              {{ lastLoginDatetimeLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispLoginuser in loginUsers"
            :key="dispLoginuser.userId"
          >
            <th class="table_checkbox">
              <input
                v-if="!dispLoginuser.postName" 
                disabled
                type="checkbox"
                class="checkbox"
                v-model="dispLoginuser.checked"
              />
              <input
                v-else
                type="checkbox"
                class="checkbox"
                v-model="dispLoginuser.checked"
                @click="checkedAction(dispLoginuser)"
              />
            </th>
            <td
              class="table_contents_loginUser_img"
              @click="setActive(dispLoginuser)"
            >
              <div class="image_loginUser" v-if="!dispLoginuser.foothold">
                <img
                  :src="
                    getImg(
                      dispLoginuser.thumbnailPhotograph,
                      dispLoginuser.userId
                    )
                  "
                />
              </div>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="careworker_name">
                {{ dispLoginuser.familyName }}{{ dispLoginuser.name }}
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="post_name" v-if="!dispLoginuser.foothold">
                {{ dispLoginuser.postName }}
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="job" v-if="!dispLoginuser.foothold">
                {{ dispLoginuser.job }}
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="position" v-if="!dispLoginuser.foothold">
                {{ dispLoginuser.position }}
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="phoneNumber">
                {{ dispLoginuser.phoneNumber }}
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="status" v-if="!dispLoginuser.foothold">
                <div v-if="dispLoginuser.statusId == 1">
                  <img class="statusIcon" :src="statusId1Icon" />
                  <div class="statusName">
                    {{ statusName1 }}
                  </div>
                </div>
                <div v-if="dispLoginuser.statusId == 2">
                  <img class="statusIcon" :src="statusId2Icon" />
                  <div class="statusName">
                    {{ statusName2 }}
                  </div>
                </div>
                <div v-if="dispLoginuser.statusId == 3">
                  <img class="statusIcon" :src="statusId3Icon" />
                  <div class="statusName">
                    {{ statusName3 }}
                  </div>
                </div>
              </label>
            </td>
            <td
              class="table_contents_loginUser"
              @click="setActive(dispLoginuser)"
            >
              <label class="lastLoginDatetime">
                {{ dispLoginuser.lastLoginDateTime }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setLoginUsers(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close"> </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import loginUserPostList from './loginUserPostList.vue'

export default {
  data() {
    return {
      careworkerNameLabel: '名前',
      postNameLabel: 'メイン所属',
      jobLabel: '職種',
      positionLabel: '役職',
      phoneNumberLabel: '電話番号',
      statusLabel: 'ステータス',
      lastLoginDatetimeLabel: '最終ログイン日時',
      dispLoginusers: [],
      findLoginUsers: [],
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      noimageIcon: require('../../img/noimageicon.png'),
      statusId1Icon: require('../../img/statusId1Icon.png'),
      statusId2Icon: require('../../img/statusId2Icon.png'),
      statusId3Icon: require('../../img/statusId3Icon.png'),
      isOpen: [],
      fileDownloadUserIDList: [],
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prev: {
        pageNo: 0,
        searchWord: '',
        postId: null
      }
    }
  },
  computed: {
    loginUsers() {
      return this.$store.state.loginUsers.loginUsers
    },
    loginUserPostList() {
      return this.$store.state.loginUsers.loginUserPostList
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.loginUsers.total) {
        return this.$store.state.loginUsers.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.loginUsers.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.loginUsers.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 158
      return this.windowHeight - otherHeight + 'px'
    },
    statusName1() {
      return this.$store.state.masters.loginUser.status.statusName1
    },
    statusName2() {
      return this.$store.state.masters.loginUser.status.statusName2
    },
    statusName3() {
      return this.$store.state.masters.loginUser.status.statusName3
    },
    changeThumbnailPhotographList() {
      return this.$store.state.loginUsers.changeThumbnailPhotographList
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('loginUsers/clearSelectedLoginUsersList')
    this.setLoginUsers()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow,
    loginUserPostList
  },
  async updated() {
    let fileDownloadUserIDList = this.fileDownloadUserIDList
    let list = []
    // 表示するリスト（最大20件）の画像をダウンロードする
    this.loginUsers.forEach(async function(item) {
      let userId = item['userId']
      let thumbnailPhotograph = item['thumbnailPhotograph']
      // データが更新され､且つ DOM に適用される度に本メソッドが呼ばれるため、画像取得済みのユーザは再ダウンロード処理を実行しない
      let data = fileDownloadUserIDList.filter(function(row) {
        return row.userId === userId
      })
      if (data.length === 0) {
        fileDownloadUserIDList.push({userId})
        list.push({userId, thumbnailPhotograph})
      }
    })
    if (list.length !== 0) {
      await this.$store.dispatch('loginUsers/fileDownloadList', list)
    }
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    close(e) {
      this.showFalseModal = false
    },
    checkedAction(loginUser) {
      loginUser.checked = !loginUser.checked
      this.$store.dispatch('loginUsers/updateSelectedLoginUsersList', [loginUser])
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      if (this.loginUsers.length === 0) {
        return
      }
      for (let i = 0; i < this.loginUsers.length; i++) {
        if(! this.loginUsers[i].postName){
        }else{this.loginUsers[i].checked = this.checked
        }
      }
      this.$store.dispatch(
        'loginUsers/updateSelectedLoginUsersList',
        this.loginUsers
      )
    },
    createLoginusersList(e) {
      // 表示するリストをページネーションから受け取る。
      this.dispLoginusers = e
      this.checked = false
    },
    async reload() {
      this.setLoginUsers(this.prev.pageNo)
    },
    async setLoginPostUsers(postId) {
      this.prev.postId = postId
      this.$store.dispatch('loginUsers/clearSelectedLoginUsersList')
      this.setLoginUsers()
    },
    async setLoginUsers(pageNo = null, searchWord = null) {
      searchWord = searchWord === null ? this.prev.searchWord : searchWord
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      this.$store.dispatch('loginUsers/clearChangeThumbnailPhotographList')
      this.fileDownloadUserIDList = []
      try {
        if (pageNo === null) {
          await this.$store.dispatch('loginUsers/setLoginUsers', {
            userDataBlankFlag: true
          })
        }
        if (pageNo === null) {
          pageNo = 0
        }
        this.prev.pageNo = pageNo
        this.prev.searchWord = searchWord
        if (this.page === pageNo + 1) {
          await this.$store.dispatch('loginUsers/setLoginUsers', {
            pageNo: pageNo,
            searchWord: searchWord,
            postId: this.prev.postId
          })
          if (location.pathname !== '/loginUsers') {
            this.$router.push('/loginUsers')
          }
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = pageNo + 1
        }
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_600001
        let eventType = 3
        let reason = 'MSGCRC0193 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0193.name +
            this.errorMsg.MSGCRC0193.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      let strHours = '00' + new Date().getHours()
      let strMinutes = '00' + new Date().getMinutes()
      let lastUpdateDateTime =
        new Date().toLocaleDateString() +
        ' ' +
        strHours.substr(-2) +
        ':' +
        strMinutes.substr(-2)
      this.$store.dispatch('loginUsers/setLastUpdateDateTime', lastUpdateDateTime)
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('loginUsers/setDetailLoginUser', payload)
        if (location.pathname !== '/loginUsers/detail') {
          this.$router.push('../loginUsers/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_600002
        let eventType = 3
        let reason = 'MSGCRC0194 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0194.name +
            this.errorMsg.MSGCRC0194.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    clearIsOpen(e) {
      this.isOpen = e
      this.$refs.child1.clearIsOpen(this.isOpen)
    },
    getImg(thumbnailPhotograph, userId) {
      if (thumbnailPhotograph === null) {
        return this.noimageIcon
      } else {
        var data = this.changeThumbnailPhotographList.filter(function(row) {
          return row.id === userId
        })
        if (data.length === 0) {
          return this.noimageIcon
        } else {
          return data[0].img
        }
      }
    },
    clearFileDownloadUserIDList(e) {
      this.fileDownloadUserIDList = []
    }
  }
}
</script>

<style scoped>
.table_contents_loginUser {
  table-layout: fixed;
  width: 13%;
}
.table_contents_loginUser_img {
  table-layout: fixed;
  width: 90px;
  min-width: 34px;
}
td:nth-child(4) {
  table-layout: fixed;
  width: 22%;
}
.center_loginUser {
  width: calc(100% - 221px);
  height: 86%;
  float: right;
}
.statusIcon {
  width: 25px;
  vertical-align: middle;
  float: left;
}
.statusName {
  vertical-align: middle;
}
.image_loginUser {
  height: 100%;
  width: 50%;
  display: inline-block;
  vertical-align: middle;
}
.image_loginUser img {
  overflow: auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 2px;
}
.status {
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/loginUsers/loginUsersList.vue